module.exports = __webpack_public_path__ + "img/listPic3.6236383c.jpg";